import { Dialog } from '@headlessui/react';
import { useFormik } from 'formik';
import React from 'react';

import { postUploadScheduler } from '../api/POST_uploadScheduler';
import { FormXlsx } from '../pages/inventory-control/Home.type';
import Alert from './Alert';
import Modal from './Modal';

const ModalFormXlsx = (props: {
	cancelButtonRef: React.MutableRefObject<null>;
	showModal: boolean;
	closeModal: () => void;
	showModalSuccess: () => void;
	closeModalBackground: () => void;
}) => {
	const fileInputRef = React.useRef(null);

	const toggleLoading = () => setFieldValue('isLoading', !values.isLoading);
	const toggleUploadFile = () =>
		setFieldValue('isUploadSuccess', !values.isUploadSuccess);

	const handleOnFileLoad = (event: React.ChangeEvent<HTMLInputElement>) => {
		const fileList = event.target.files;
		setFieldValue('file', fileList[0]);
		toggleUploadFile();
	};

	const handleRemoveFile = () => {
		fileInputRef.current = null;
		setFieldValue('file', null);
		setFieldValue('isAlertVisible', false);
		toggleUploadFile();
	};

	const { values, handleSubmit, setFieldValue, resetForm } =
		useFormik<FormXlsx>({
			initialValues: {
				file: null,
				isUploadSuccess: false,
				isLoading: false,
				isAlertVisible: false,
				errorMessage: '',
			},
			validateOnMount: true,
			onSubmit: async (formValues) => {
				const formData = new FormData();
				formData.append('file', formValues.file);
				await postUploadScheduler(formData).then(
					({ status, messageDescription }) => {
						if (status === 'success') {
							toggleLoading();
							props.closeModal();
							props.showModalSuccess();
							resetForm({
								values: {
									file: null,
									isUploadSuccess: false,
									isLoading: false,
									isAlertVisible: false,
									errorMessage: '',
								},
							});
						} else {
							setFieldValue('errorMessage', messageDescription);
							setFieldValue('isAlertVisible', true);
							toggleLoading();
						}
					},
				);
			},
		});

	const onSubmit = () => {
		toggleLoading();
		handleSubmit();
	};

	const onCancel = () => {
		if (values.file) {
			handleRemoveFile();
		}
		props.closeModal();
	};

	return (
		<Modal
			cancelButtonRef={props.cancelButtonRef}
			isShowModal={props.showModal}
			closeModalBackground={props.closeModalBackground}
		>
			<div className="mb-6">
				{values.isAlertVisible && (
					<Alert showAlert={values.isAlertVisible} text={values.errorMessage} />
				)}
				<Dialog.Title
					as="div"
					className="text-left text-extraLarge text-gray-gray700 font-interMedium mb-6"
				>
					Import Excel
				</Dialog.Title>
				<div className="mb-6">
					{values.isUploadSuccess ? (
						<div
							className={
								values.isAlertVisible
									? 'w-full h-24 border-2 flex justify-between items-center border-dashed rounded-lg border-danger-default p-4'
									: 'w-full h-24 border-2 flex justify-between items-center border-dashed rounded-lg border-gray-gray400 p-4'
							}
						>
							<div className="flex justify-center items-center">
								<img src="/images/tnc.svg" className="mr-2" />
								<div
									className={
										values.isAlertVisible
											? 'text-large text-danger-default font-interMedium'
											: 'text-large text-primary-green font-interMedium'
									}
								>
									{values.file.name}
								</div>
							</div>
							<div onClick={handleRemoveFile} className="cursor-pointer">
								<img src="/images/remove.svg" />
							</div>
						</div>
					) : (
						<div>
							<button
								className="w-full h-24 border-2 flex justify-center items-center border-dashed rounded-lg border-gray-gray400 cursor-pointer"
								onClick={() => fileInputRef?.current.click()}
							>
								<div className="flex justify-center items-center">
									<img src="/images/upload.svg" className="mr-2" />
									<div className="text-large text-gray-gray400 font-interRegular">
										Tambahkan File Template
									</div>
								</div>
							</button>
							<input
								onChange={handleOnFileLoad}
								multiple={false}
								ref={fileInputRef}
								type="file"
								hidden
							/>
						</div>
					)}
				</div>
				<p className="text-large text-center text-gray-gray500 font-interRegular">
					Pastikan kamu menggunakan format file yang disediakan oleh sistem.
					<a
						href={`${process.env.REACT_APP_BASE_URL}/download-scheduler-template`}
						className="text-primary-green font-interMedium"
					>
						Download disini
					</a>
				</p>
			</div>
			<div className="flex space-x-4">
				<button
					type="button"
					className="w-1/2 p-4 text-center border-2 border-primary-green bg-white rounded-lg text-primary-green font-interSemiBold focus:outline-none focus:ring-transparent"
					onClick={onCancel}
					ref={props.cancelButtonRef}
				>
					Batal
				</button>
				<button
					disabled={!values.isUploadSuccess || values.isLoading}
					type="button"
					className={
						!values.isUploadSuccess
							? 'w-1/2 p-4 flex justify-center items-center text-center rounded-lg bg-gray-gray300 focus:outline-none focus:ring-transparent focus:ring-primary-green cursor-default'
							: 'w-1/2 p-4 flex justify-center items-center text-center rounded-lg bg-primary-green focus:outline-none focus:ring-transparent focus:ring-primary-green'
					}
					onClick={onSubmit}
				>
					{values.isLoading ? (
						<div>
							<img src="/images/spinner.gif" className="w-6 h-6" />
						</div>
					) : (
						<div
							className={
								!values.isUploadSuccess
									? 'text-large text-gray-gray500 font-interSemiBold'
									: 'text-large text-white font-interSemiBold'
							}
						>
							Simpan
						</div>
					)}
				</button>
			</div>
		</Modal>
	);
};

export default ModalFormXlsx;
